<template>
  <el-dialog title="打折" :visible.sync="dialogVisible" @closed="close" width="750px" class="discount-comp">
    <div v-loading="loading">
      <el-tabs value="cost">
        <el-tab-pane label="费用明细" name="cost">
          <table class="native-table">
            <tr>
              <th>项目名称</th>
              <th>应收金额（元）</th>
              <th>实收金额（元）</th>
            </tr>
            <tr>
              <td>学费</td>
              <td>
                {{ current_class_info.class_fee }}
              </td>
              <td>
                {{
                  Decimal.mul(
                    Decimal.sub(signUpInfo.origin_class_fee || 0, this.shitNoPay('current_class_info')),
                    rate ? rate : 0
                  ).toNumber()
                }}
              </td>
            </tr>
            <tr>
              <td>保险费</td>
              <td>
                {{ current_class_info.insurance }}
              </td>
              <td>
                <el-input
                  v-model="otherPayFormData.real_insurance"
                  @change="value => changeOtherPay(value, 'insurance')"
                ></el-input>
              </td>
            </tr>
            <tr>
              <td>材料费</td>
              <td>
                {{ current_class_info.material_fee }}
              </td>
              <td>
                <el-input
                  v-model="otherPayFormData.real_material_fee"
                  @change="value => changeOtherPay(value, 'material_fee')"
                ></el-input>
              </td>
            </tr>
            <tr>
              <td>伙食费</td>
              <td>
                {{ current_class_info.food_expenses }}
              </td>
              <td>
                <el-input
                  v-model="otherPayFormData.real_food_expenses"
                  @change="value => changeOtherPay(value, 'food_expenses')"
                ></el-input>
              </td>
            </tr>
<!--            <tr>
              <td>陪读费</td>
              <td>
                {{ current_class_info.accompanying_fee }}
              </td>
              <td>
                <el-input
                  v-model="otherPayFormData.real_accompanying_fee"
                  @change="value => changeOtherPay(value, 'accompanying_fee')"
                ></el-input>
              </td>
            </tr>-->
<!--            <tr>
              <td>托管费</td>
              <td>
                {{ current_class_info.hosting_fee }}
              </td>
              <td>
                <el-input
                  v-model="otherPayFormData.real_hosting_fee"
                  @change="value => changeOtherPay(value, 'hosting_fee')"
                ></el-input>
              </td>
            </tr>-->
                        <tr v-if='refund_type === 2'>
              <td>食宿交通门票等</td>
              <td>
                {{ current_class_info.accommodation_traffic_ticket }}
              </td>
              <td>
                <el-input
                  v-model="otherPayFormData.real_accommodation_traffic_ticket"
                  @change="value => changeOtherPay(value, 'accommodation_traffic_ticket')"
                ></el-input>
              </td>
            </tr>
            <tr>
              <td>总计</td>
              <td>
                {{ current_class_info.total_fee }}
              </td>
              <td>
                {{ signUpInfo.class_fee && totalPay('current_class_info') }}
              </td>
            </tr>
          </table>

          <div class="reason">
            <span class="title">折扣理由</span>
            <el-select
              filterable
              @change="changeDisCount"
              value-key="id"
              size="medium"
              v-model="curDisCount"
              :disabled="!isEdit"
              placeholder="请选择"
            >
              <el-option v-for="item in discountReason" :key="item.id" :label="item.reason" :value="item"></el-option>
            </el-select>
            <el-input
              v-model.trim="rateTmp"
              placeholder="折扣率"
              size="medium"
              class="rate"
              :disabled="isEdit ? isEdit && !curDisCount.id : !isEdit"
            >
              <el-button slot="append">%</el-button>
            </el-input>
            <el-button type="text" v-if="!isEdit" size="medium" @click.native="isEdit = true">编辑</el-button>
          </div>
          <div class="result">
            <span class="title">折扣详情</span>
            <span class="label">
              ({{ current_class_info.class_fee }}
              <span class="mini">（原价）</span>
              <span v-if="signUpInfo.shift_class_number">
                - {{ signUpInfo.shift_class_number }}
                <span class="mini">（错过课程数）</span>
                * {{ signUpInfo.single_class_price }}
                <span class="mini">（单节课价）</span>
              </span>
              )* {{ !rate && rate !== 0 ? 1 : rate }}
              <span class="mini">（折扣率）</span>
              + 其他费用 =
              <strong
                >{{ totalPay('current_class_info') }}（元）</strong
              >
            </span>
          </div>
        </el-tab-pane>
        <el-tab-pane label="基础信息" name="base">
          <ul class="base-list">
            <li>
              <span class="label">学年</span>
              <span class="value">{{ signUpInfo.year }}</span>
            </li>
            <li>
              <span class="label">上课老师</span>
              <span class="value">{{ signUpInfo.teacher.map(item => item.real_name).join(',') }}</span>
            </li>
            <li>
              <span class="label">学期</span>
              <span class="value">{{ signUpInfo.term_label }}</span>
            </li>
            <!-- <li>
              <span class="label">收费人</span>
              <span class="value"></span>
            </li>
            <li>
              <span class="label">收费时间</span>
              <span class="value">{{signUpInfo.pay_time}}</span>
            </li> -->
            <li>
              <span class="label">所属部门</span>
              <span class="value">{{ signUpInfo.org_full_name }}</span>
            </li>
            <li>
              <span class="label">项目名称</span>
              <span class="value">{{ signUpInfo.specialized_subject_full_name }}</span>
            </li>
            <li>
              <span class="label">报名时间</span>
              <span class="value">{{ signUpInfo.create_time }}</span>
            </li>
            <li>
              <span class="label">班级名称</span>
              <span class="value">{{ signUpInfo.name }}</span>
            </li>
            <li>
              <span class="label">班级总费用</span>
              <span class="value">{{ signUpInfo.total_fee }}（元）</span>
            </li>
          </ul>
        </el-tab-pane>
      </el-tabs>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="discountSubmit">保 存</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { Dialog, Select, Option, Tabs, TabPane, Input } from 'element-ui';
import { contact } from '@/api';
import pattern from '@/utils/pattern';

const Decimal = require('decimal.js/decimal.js');

export default {
  name: 'DiscountComp',
  components: {
    ElDialog: Dialog,
    ElTabs: Tabs,
    ElTabPane: TabPane,
    ElSelect: Select,
    ElOption: Option,
    ElInput: Input
  },
  props: {
    sign_up_id: {
      required: true
    }
  },
  computed: {
    // 除去学费的其他费用
    otherPay() {
      // key为 current_class_info or signUpInfo 用于计算班级变动前和变动后价格
      return key => {
        const info = this[key];
        if (key === 'current_class_info') {
          try {
            if (info.class_fee) {
              return Decimal.add(this.otherPayFormData.real_material_fee, this.otherPayFormData.real_insurance)
                .add(this.otherPayFormData.real_food_expenses)
                .add(this.otherPayFormData.real_accompanying_fee)
                .add(this.otherPayFormData.real_hosting_fee)
                .add(this.otherPayFormData.real_accommodation_traffic_ticket)
                .toNumber();
            }
            return 0;
          } catch (error) {
            return 0;
          }
        }
        try {
          if (info.class_fee) {
            return Decimal.add(info.material_fee, info.insurance)
              .add(info.food_expenses)
              .add(info.accompanying_fee)
              .add(info.hosting_fee)
              .add(info.accommodation_traffic_ticket)
              .toNumber();
          }
          return 0;
        } catch (error) {
          return 0;
        }
      };
    },
    // 插班错过的费用
    shitNoPay() {
      return key => {
        const info = this[key];
        try {
          if (info.class_fee) {
            return Decimal.mul(info.single_class_price, this.allSignUp.shift_class_number || 0).toNumber();
          }
          return 0;
        } catch (e) {
          return 0;
        }
      };
    },
    // 总费用
    totalPay() {
      return key => {
        const info = this[key];
        let { rate } = this;
        if (key === 'signUpInfo') rate = this.allSignUp.sign_up.discount_rate || 1;
        try {
          if (info.class_fee) {
            return Decimal.mul(Decimal.sub(info.class_fee, this.shitNoPay(key)), rate)
              .add(this.otherPay(key))
              .toNumber();
          }
          return 0;
        } catch (e) {
          return 0;
        }
      };
    },
    rateTmp: {
      get() {
        try {
          if (this.curDisCount.id) return Decimal.mul(this.rate, 100).toNumber();
          return '';
        } catch (e) {
          return '';
        }
      },
      set(value) {
        try {
          if (pattern.percent.test(value)) {
            this.rate = Decimal.div(value, 100).toNumber();
            return;
          }
          if (value === '') this.rate = '';
        } catch (error) {
          this.rate = '';
        }
      }
    },
    // 班级费用和上次打折时是否有变动
    isChangeClassFee() {
      const { current_class_info, signUpInfo } = this;
      return !(
        current_class_info.class_fee === signUpInfo.origin_class_fee
        && current_class_info.insurance === signUpInfo.insurance
        && current_class_info.hosting_fee === signUpInfo.hosting_fee
        && current_class_info.food_expenses === signUpInfo.food_expenses
        && current_class_info.accompanying_fee === signUpInfo.accompanying_fee
        && current_class_info.material_fee === signUpInfo.material_fee
      );
    }
  },
  data() {
    return {
      refund_type: 1,
      isEdit: false,
      dialogVisible: false,
      loading: false,
      signUpInfo: {
        teacher: [],
        discount_reason_id: ''
      },
      current_class_info: {},
      discountReason: [],
      curDisCount: {},
      rate: 1,
      Decimal,
      otherPayFormData: {
        real_material_fee: '',
        real_insurance: '',
        real_food_expenses: '',
        real_accompanying_fee: '',
        real_hosting_fee: '',
        accommodation_traffic_ticket: ''
      }
    };
  },
  methods: {
    init() {
      if (this.sign_up_id === '') return;
      this.loading = true;
      contact
        .getSignUpInfo({
          params: {
            sign_up_id: this.sign_up_id
          }
        })
        .then(res => {
          if (res && res.data) {
            const { sign_up } = res.data;
            // 缓存所有原始数据
            this.allSignUp = sign_up;

            if (!sign_up.current_class_info) return;

            this.current_class_info = sign_up.current_class_info;

            this.otherPayFormData = {
              real_material_fee: sign_up.sign_up.material_fee,
              real_insurance: sign_up.sign_up.insurance,
              real_food_expenses: sign_up.sign_up.food_expenses,
              real_accompanying_fee: sign_up.sign_up.accompanying_fee,
              real_hosting_fee: sign_up.sign_up.hosting_fee,
              real_accommodation_traffic_ticket: sign_up.sign_up.accommodation_traffic_ticket
            };

            this.signUpInfo = {
              ...sign_up,
              ...sign_up.sign_up,
              teacher: sign_up.teacher,
              discount_reason_id: sign_up.sign_up.discount_reason_id || sign_up.current_class_info.discount_reason_id
            };
            if (this.signUpInfo.discount_reason_id) {
              this.curDisCount = {
                id: sign_up.sign_up.discount_reason_id
              };
              this.rate = sign_up.sign_up.discount_rate;
            } else {
              this.curDisCount = {};
              this.rate = 1;
            }
            this.loading = false;
          }
        });
      if (this.discountReason.length) return;
      contact.discountReasonQuery().then(res => {
        if (res) {
          this.discountReason = res.data.list;
        }
      });
    },
    open(refund_type) {
      this.refund_type = refund_type;
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.init();
      });
    },
    changeDisCount(item) {
      this.signUpInfo = {
        ...this.signUpInfo,
        discount_rate: item.rate
      };
      this.rate = item.rate;
    },
    async discountSubmit() {
      const res = await contact.discountSignUp({
        params: {
          sign_up_id: this.sign_up_id,
          discount_reason_id: this.curDisCount.id,
          discount_rate: this.rate,
          sign_up_fee: this.totalPay('current_class_info'),
          discount_reduction: Decimal.sub(1, this.signUpInfo.discount_rate || 1)
            .mul(this.current_class_info.class_fee)
            .toNumber(),
          sign_up_reduction: Decimal.mul(
            this.allSignUp.shift_class_number,
            this.current_class_info.single_class_price
          ).toNumber(),
          fee_level_id: this.current_class_info.fee_level_id,
          real_class_fee: Decimal.sub(
            this.totalPay('current_class_info'),
            this.otherPay('current_class_info')
          ).toNumber(),
          ...this.otherPayFormData,
          sign_up_origin_class_fee: this.current_class_info.class_fee,
          sign_up_origin_single_class_fee: this.current_class_info.single_class_price,
          class_total_count: this.current_class_info.courses_count - this.allSignUp.shift_class_number,
          sign_up_discount_single_class_fee: Decimal.mul(
            this.current_class_info.single_class_price,
            this.rate
          ).toNumber()
        }
      });
      if (res) {
        this.$message.success(res.msg || '打折成功');
        this.$emit('success');
      } else {
        return;
      }
      this.close();
    },
    changeOtherPay(value, key) {
      const temp = Number(value);
      const oldValue = this.current_class_info[key];
      if (!pattern.positiveDecimal.test(temp) || temp > oldValue) {
        this.otherPayFormData[`real_${key}`] = oldValue;
      }
    },
    close() {
      this.dialogVisible = false;
      this.isEdit = false;
    }
  }
};
</script>

<style lang="less">
.discount-comp {
  .native-table {
    .el-input {
      width: 250px;
      margin: 5px 15px;
    }
  }
  .el-dialog__body {
    padding: 0 20px;
  }
  .base-list {
    list-style: none;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    li {
      min-width: 250px;
      margin: 10px 5px;
      .label {
        display: inline-block;
        width: 100px;
        font-weight: 700;
      }
    }
  }
  .reason,
  .result {
    margin-top: 20px;
    .mini {
      font-size: 12px;
      color: #999;
    }
    .title {
      width: 100px;
      display: inline-block;
      font-weight: 700;
    }
    strong {
      color: @danger;
    }
  }
  .rate {
    width: 150px;
    margin: 0 10px;
  }
  del {
    font-size: 12px;
    color: #999;
  }
}
</style>
